import store from '../store/index'
import Vue from 'vue'

export default (req, next) => {
  return ({ status, body }) => {
    if (status == 401) {
      store.dispatch('auth/ActionSignOut')
      window._Vue.$router.push({ path: '/auth' })
    } else if (status == 402) {
      Vue.swal({
        icon: 'error',
        title: 'Erro',
        text: body.message,
      })
    }
  }
}
